import * as React from "react"
import {Box} from "@mui/material";
import {formatPrice} from "@ui-seeker/utils";


export default function referencePriceColumn(name, label) {
	return {
		name, label,
		options: {
			filter: false,
			customBodyRowRenderLite: (value, { currency }) => <Box sx={{ display: 'flex', justifyContent: 'center' }}>
				{formatPrice(value, currency)}
			</Box>
		}
	}
}